import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Grid, Typography, Button,  useMediaQuery, 
    FormControlLabel, Box, FormControl,
   Radio, RadioGroup,
    TextareaAutosize
} from "@mui/material";
import { useParams, Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { fetchData, postData } from '../../../../redux/apiSlice';
import { getIn } from 'formik';

function ServiceStep3({ onNext,onPrevious,formData,transformedVideoData }) {
    const dispatch = useDispatch();
    const disabledVideoIds = transformedVideoData.map(video => video.service_id);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [mediaServiceVideosTemplate, setMediaServiceVideosTemplate] = useState([]);
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    
    const fetchMediaServiceVideosTemplate = async () => {
        handleFreezStart();
        const apiUrl = '/mediaServiceVideosTemplate';
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
            setMediaServiceVideosTemplate(res.data);
            handleFreezStop();
        }else{
            handleFreezStop();
        }
    }
    useEffect(() => {
        fetchMediaServiceVideosTemplate();
    }, [])

   const validationSchema = Yup.object().shape({
  videos: Yup.array().of(
    Yup.object().shape({
      selectedOption: Yup.string().required('Selection is required'),
      video_script: Yup.string()
        .max(1000, 'Description cannot exceed 1000 characters')
        .when('selectedOption', {
        is: 'coaching',
        then: (schema) => schema.required('Video script is required for coaching'),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      template_id: Yup.string().when('selectedOption', {
        is: 'templates',
        then: (schema) => schema.required('Please Select Template'),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
    })
  ),
});

    
    return (
        <>
            <Box p={2}>
                <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} mb={2}>
                    <Typography variant="h6" fontWeight={"bolder"}  sx={{ textTransform: "capitalize" }}>We'll send you proven scripts to guide your videos. Choose your preference:</Typography>
                </Grid>
                <Formik
                    initialValues={{
                        videos: formData?.video_data?.map((video, index) => ({
                            service_id: video.id,
                            title: video.title,
                            video_script: formData?.videos?.[index]?.video_script || "",
                            selectedOption: formData?.videos?.[index]?.selectedOption || "coaching",
                            template_id: formData?.videos?.[index]?.template_id || ""
                          })) || []
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, errors) => {
                        onNext(values);
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values,setFieldValue,errors, touched, }) => (
                        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                            {values.videos.map((videoData, index) => (
                                <Box key={index} sx={{ mb: 2, width:"100%" }}>
                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                        <Typography variant="h6" fontWeight={600}  sx={{textTransform:"capitalize"}}>Video {index + 1} ( {videoData.title} )</Typography>
                                    </Grid>
                                    {(() => {
                                    const isDisabled = disabledVideoIds.includes(videoData.service_id);

                                    return (
                                        <>
                                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <FormControlLabel
                                                    control={
                                                        <Radio
                                                        checked={videoData.selectedOption === 'coaching'}
                                                        onChange={() => {
                                                            if (!isDisabled) {
                                                                setFieldValue(`videos[${index}].selectedOption`, "coaching");
                                                                setFieldValue(`videos[${index}].template_id`, "");
                                                            }
                                                        }}
                                                        disabled={isDisabled}
                                                        />
                                                    }
                                                    label="I’ll write my own (with coaching)"
                                                    sx={{textTransform:"capitalize"}}
                                                    />
                                                    {videoData.selectedOption === 'coaching' && (
                                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                                        {(() => {
                                                            const error = getIn(errors, `videos[${index}].video_script`);
                                                            const touch = getIn(touched, `videos[${index}].video_script`);
                                                            return (
                                                            <>
                                                                <TextareaAutosize
                                                                minRows={6}
                                                                placeholder="Description"
                                                                value={videoData.video_script}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                name={`videos[${index}].video_script`}
                                                                style={{
                                                                    width: '100%',
                                                                    borderColor: touch && error ? 'red' : '#ccc',
                                                                    borderWidth: '1px',
                                                                    borderStyle: 'solid',
                                                                    padding: '8px',
                                                                }}
                                                                disabled={isDisabled}
                                                                />
                                                                {touch && error && (
                                                                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                                                    {error}
                                                                </Typography>
                                                                )}
                                                            </>
                                                            );
                                                        })()}
                                                        </FormControl>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControlLabel
                                                    control={
                                                        <Radio
                                                        checked={videoData.selectedOption === 'templates'}
                                                        onChange={() => {
                                                            if (!isDisabled) {
                                                                setFieldValue(`videos[${index}].selectedOption`, "templates");
                                                                setFieldValue(`videos[${index}].video_script`, "");
                                                            }
                                                        }}
                                                        disabled={isDisabled}
                                                        />
                                                    }
                                                     sx={{textTransform:"capitalize"}}
                                                    label="Use Default Script"
                                                    />
                                                </Grid>
                                            </Grid>

                                            {videoData.selectedOption === 'templates' && (
                                                <Grid container spacing={isMobile ? 0 : 2} >
                                                    {/* {mediaServiceVideosTemplate */}
                                                    {mediaServiceVideosTemplate
                                                    .filter((template) => template.md_service_id === videoData.service_id)
                                                    .map((template) => (
                                                        <>
                                                            <Grid item lg={4} md={4} xs={12} sm={12} key={template.id} sx={{display:"flex",flexGrow:1}} >
                                                                
                                                                <Box
                                                                // onClick={() => {
                                                                //     if (!isDisabled) {
                                                                //     setFieldValue(`videos[${index}].template_id`, template.id);
                                                                //     }
                                                                // }}
                                                                sx={{
                                                                    width: '100%',
                                                                    border: videoData.template_id === template.id ? '2px solid black' : '1px solid #ccc',
                                                                    cursor: isDisabled ? "default" : "pointer",
                                                                    padding: 1, // Add spacing around the iframe
                                                                    borderRadius: 1,
                                                                    boxSizing: 'border-box',
                                                                    mb: 2, // vertical gap between multiple boxes
                                                                    
                                                                }}
                                                                >
                                                                    <FormControlLabel
                                                                    control={
                                                                        <Radio
                                                                        checked={videoData.template_id === template.id}
                                                                        onChange={() => {
                                                                            if (!isDisabled) {
                                                                            setFieldValue(`videos[${index}].template_id`, template.id);
                                                                            }
                                                                        }}
                                                                        name={`videos[${index}].template_id`} // Grouping by video index
                                                                        />
                                                                    }
                                                                    label={
                                                                        <Typography fontWeight="bold" sx={{ textTransform: "capitalize" }}>
                                                                        {template.style}
                                                                        </Typography>
                                                                    }
                                                                    />
                                                                    {/* <Typography>{template.style}</Typography> */}
                                                                    <Typography sx={{textTransform:"capitalize"}}>{template.script}</Typography>
                                                                {/* <iframe
                                                                    src={template.template_url}
                                                                    title={`template-${template.id}`}
                                                                    allow="autoplay; encrypted-media"
                                                                    allowFullScreen
                                                                    style={{
                                                                    width:"100%",
                                                                    height:"315",
                                                                    border: 'none',
                                                                    pointerEvents: isDisabled ? "none" : "auto",
                                                                    }}
                                                                /> */}
                                                                </Box>
                                                            </Grid>
                                                        </>
                                                    ))}
                                                    {(() => {
                                                        const error = getIn(errors, `videos[${index}].template_id`);
                                                        const touch = getIn(touched, `videos[${index}].template_id`);
                                                        return (
                                                        touch &&
                                                        error && (
                                                            <Grid item xs={12}>
                                                            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                                                {error}
                                                            </Typography>
                                                            </Grid>
                                                        )
                                                        );
                                                    })()}
                                                </Grid>
                                            )}
                                        </>
                                    );
                                    })()}
                                </Box>
                            ))}
                            <Grid container item lg={12} md={12} sm={12} xs={12} mb={2}>
                                <Typography color={"#2A9005"} fontWeight={"bolder"} textTransform={"capitalize"} textAlign={isMobile?"center":"flex-start"}><i>***We'll also send example videos that match your vibe or industry for inspiration.***</i></Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={isMobile?"center":"left"} gap={2} mt={1}>
                                <Button variant="contained" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} type='submit'>NEXT</Button>
                                <Button variant="outlined" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} onClick={() => onNext()}>SKIP</Button>
                                <Button variant="text" color='primary' sx={{ minWidth: 200, fontWeight: "bold", fontSize: "15px" }} onClick={onPrevious}>previous step</Button>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </Box>
        </>
    )
}
export default ServiceStep3;